import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	name: Yup.string().required().label('Name'),
	url: Yup.string().nullable().label('Url'),
	primaryColor: Yup.string().nullable().label('Primary Color'),
	countryIds: Yup.array().of(Yup.number()).nullable().label('Country Ids'),
	excludeCountryIds: Yup.array().of(Yup.number()).nullable().label('Exclude Country Ids'),
	offers: Yup.array()
		.of(
			Yup.object().shape({
				text: Yup.string().nullable().label('Text'),
				disclaimer: Yup.string().nullable().label('Disclaimer'),
				link: Yup.string().nullable().label('Link'),
				buttonText: Yup.string().nullable().label('Button Text'),
				countryIds: Yup.array().of(Yup.number()).nullable().label('Countries'),
			})
		)
		.nullable()
		.label('Offers'),
});

const Inputs = [
	{
		name: 'name',
		label: 'Name',
		type: 'text',
		value: 'single',
		valueAttr: 'name',
		required: true,
	},
	{
		name: 'url',
		label: 'Url',
		type: 'text',
		value: 'single',
		valueAttr: 'url',
	},
	{
		name: 'primaryColor',
		label: 'Primary Color (hex)',
		type: 'text',
		value: 'single',
		valueAttr: 'primaryColor',
	},
	{
		name: 'logoFile',
		label: 'Logo',
		type: 'image',
		value: 'single',
		valueAttr: 'logo',
		onChange: (localValues: any, event: any) => {
			localValues['logoFile'] = event.target.files[0];
			localValues['logo'] = URL.createObjectURL(event.target.files[0]);
		},
		clearImage: (localValues: any) => {
			const el = document.getElementById('logoFile') as HTMLInputElement | null;
			if (el) el.value = '';
			localValues['logoFile'] = '';
			localValues['logo'] = '';
		},
		transform: (path: string) => {
			if (!path) return path;
			if (path.includes('blob')) return path;
			if (path.startsWith('http')) return path;
			return process.env.VUE_APP_ASSETS_URL + '/' + path;
		},
	},
	{
		name: 'countryIds',
		label: 'Countries',
		type: 'select',
		value: 'multiple',
		valueAttr: 'countryIds',
	},
	{
		name: 'excludeCountryIds',
		label: 'Exclude Countries',
		type: 'select',
		value: 'multiple',
		valueAttr: 'excludeCountryIds',
	},
	{
		name: 'offers',
		label: 'Offers',
		type: 'nestedArray',
		value: 'multiple',
		valueAttr: 'offers',
		collapsible: true,
		summaryFn: (row: any) => row.text || 'Offer',
		columns: [
			{
				name: 'text',
				label: 'Text',
				type: 'textarea',
				value: 'single',
				valueAttr: 'text',
			},
			{
				name: 'disclaimer',
				label: 'Disclaimer',
				type: 'textarea',
				value: 'single',
				valueAttr: 'disclaimer',
			},
			{
				name: 'link',
				label: 'Link',
				type: 'text',
				value: 'single',
				valueAttr: 'link',
			},
			{
				name: 'buttonText',
				label: 'Button Text',
				type: 'text',
				value: 'single',
				valueAttr: 'buttonText',
				defaultValue: 'Claim offer',
			},
			{
				name: 'countryIds',
				label: 'Countries (empty = everywhere)',
				type: 'select',
				value: 'multiple',
				valueAttr: 'countryIds',
				relationshipName: 'countryIds',
				enableOrder: false,
				// Greece-only offer → prefill the mandatory Greek gambling disclaimer (if empty)
				onChangeCallback: (row: any, val: any, relationships: Record<string, any[]> | undefined) => {
					const ids: any[] = Array.isArray(val) ? val : [];
					if (ids.length !== 1) return;
					const country = relationships?.countryIds?.find((c: any) => c.id === Number(ids[0]));
					const isGreece = country && (
						String(country.countryCode || '').toUpperCase() === 'GR' || country.name === 'Greece'
					);
					if (isGreece && !row.disclaimer) {
						row.disclaimer = 'ΕΕΕΠ | 21+ | ΠΑΙΞΕ ΥΠΕΥΘΥΝΑ';
					}
				},
			},
		],
	},
];

export { Inputs, validationSchema };
